import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { DesignPackageServices } from "@/services/bedrock/DesignPackageServices";
import { DesignPackageStatsResponse } from "@/services/bedrock/dtos/DesignPackage";
import { designKeys } from "@/services/bedrock/queryKeys";

export const STATS_STALE_TIME_MS = 60_000;

/**
 * A design's post performance. useDesignPackageChannel invalidates the key when the design is
 * published or unpublished and when a coach posts it for a player.
 */
export function useDesignPackageStats(
  packageId: number,
  opts?: { enabled?: boolean }
): UseQueryResult<DesignPackageStatsResponse> {
  return useQuery({
    queryKey: designKeys.stats(packageId),
    queryFn: () => DesignPackageServices.stats(packageId),
    staleTime: STATS_STALE_TIME_MS,
    refetchOnWindowFocus: true,
    enabled: opts?.enabled ?? true,
  });
}
